<datex-grid #$gridComponent *ngIf="initialized && !$hasMissingRequiredInParams" [selection]="true" (selectionChange)="$selectionChanged($event)" [headers]="headers" [rows]="rows" [(pageSize)]="pageSize" [(pageSkip)]="pageSkip" [totalCount]="totalCount" [loadingStatus]="loadingStatus" (pageChange)="$dataLoad()" [containerStyles]="containerStyles"



>
    <ng-container topToolbar>
      <app-toolbar [toolbar]="topToolbar">
          <ng-template 
            toolbarToolDef="toggle_add_remove" let-tool>
            <ng-container  *ngIf="tool.hasButtonsToShow">
            <button mat-button
                    data-cy="button"
                    class="datex-button"
                    [disabled]="tool.control.readOnly || tool.control.disabled"
                    [ngStyle]="tool.control.styles.style"
                    [ngClass]="tool.control.styles.classes"
                    [matTooltip]="tool.control.tooltip"
                    matTooltipClass="datex-control-tooltip"
                    (click)="on_toggle_add_remove_vendorlots_clicked($event)"
                    >
              <div class="button-label">
                <ng-container *ngIf="tool.control.icon === 'datex-default-spinner'; else showIcon">
                  <div class="button-icon">
                    <i data-cy="button-icon" class="datex-default-spinner"></i>
                  </div>
                </ng-container>
                <ng-template #showIcon>
                  <div class="button-icon">
                    <i data-cy="button-icon" class="icon {{tool.control.icon}}"></i>
                  </div>
                </ng-template>
                <div data-cy="button-label" class="button-text">{{tool.control.label}}</div>
              </div>
            
            </button>
            </ng-container>
          </ng-template>
          <ng-template 
            toolbarToolDef="add_dropdown" let-tool>
            <ng-container  *ngIf="tool.hasButtonsToShow">
            <button mat-button 
                    data-cy="splitbutton"
                    class="datex-button splitbutton" 
                    [disabled]="tool.control.readOnly || tool.control.disabled"
                    [ngStyle]="tool.control.styles.style"
                    [ngClass]="tool.control.styles.classes"
                    [matMenuTriggerFor]="dropdownMenuOne"
                    [matTooltip]="tool.control.tooltip"
                    matTooltipClass="datex-control-tooltip">
              <div class="button-label">
                <div *ngIf="tool.control.icon"
                      class="button-icon">
                  <i data-cy="splitbutton-icon" class="icon {{tool.control.icon}}"></i>
                </div>
                <div data-cy="splitbutton-label" class="button-text">{{tool.control.label}}</div>
                <div class="button-icon splitbutton-drop-icon">
                  <i data-cy="splitbutton-icon" class="icon icon-ic_fluent_chevron_down_20_regular"></i>
                </div>
              </div>
            </button>
            <mat-menu #dropdownMenuOne="matMenu" class="options-menu splitbutton-menu">
              <div data-cy="splitbutton-options">
                <div *ngIf="!tool.control.buttons.add_remove_selected_vendorlots.removed" 
                    mat-menu-item 
                    class="splitbutton-item-container">
                  <button mat-button
                          data-cy="splitbutton-sub-item"
                          class="datex-button splitbutton-sub-item" 
                          [disabled]="tool.control.buttons.add_remove_selected_vendorlots.readOnly || tool.control.buttons.add_remove_selected_vendorlots.disabled"
                          [ngStyle]="tool.control.buttons.add_remove_selected_vendorlots.styles.style"
                          [ngClass]="tool.control.buttons.add_remove_selected_vendorlots.styles.classes"
                          [matTooltip]="tool.control.buttons.add_remove_selected_vendorlots.tooltip"
                          matTooltipClass="datex-control-tooltip"
                          (click)="on_add_remove_selected_vendorlots_clicked($event)">
                    <div class="button-label">
                      <div *ngIf="tool.control.buttons.add_remove_selected_vendorlots.icon"
                          class="button-icon">
                        <i data-cy="splitbutton-sub-item-icon" class="icon {{tool.control.buttons.add_remove_selected_vendorlots.icon}}"></i>
                      </div>
                      <div data-cy="splitbutton-sub-item-label"
                          class="button-text">{{tool.control.buttons.add_remove_selected_vendorlots.label}}</div>
                    </div>
                  </button>
                </div>
                <div *ngIf="!tool.control.buttons.add_remove_all_vendorlots.removed" 
                    mat-menu-item 
                    class="splitbutton-item-container">
                  <button mat-button
                          data-cy="splitbutton-sub-item"
                          class="datex-button splitbutton-sub-item" 
                          [disabled]="tool.control.buttons.add_remove_all_vendorlots.readOnly || tool.control.buttons.add_remove_all_vendorlots.disabled"
                          [ngStyle]="tool.control.buttons.add_remove_all_vendorlots.styles.style"
                          [ngClass]="tool.control.buttons.add_remove_all_vendorlots.styles.classes"
                          [matTooltip]="tool.control.buttons.add_remove_all_vendorlots.tooltip"
                          matTooltipClass="datex-control-tooltip"
                          (click)="on_add_remove_all_vendorlots_clicked($event)">
                    <div class="button-label">
                      <div *ngIf="tool.control.buttons.add_remove_all_vendorlots.icon"
                          class="button-icon">
                        <i data-cy="splitbutton-sub-item-icon" class="icon {{tool.control.buttons.add_remove_all_vendorlots.icon}}"></i>
                      </div>
                      <div data-cy="splitbutton-sub-item-label"
                          class="button-text">{{tool.control.buttons.add_remove_all_vendorlots.label}}</div>
                    </div>
                  </button>
                </div>
              </div>
            </mat-menu>
            </ng-container>
          </ng-template>
      </app-toolbar>
    <div class="query-filter">
      <input
        matInput
        [(ngModel)]="fullTextSearch" 
        (ngModelChange)="reload()" 
        [ngModelOptions]="{updateOn: 'blur'}"
        autocomplete="off"
        class="datex-textbox query-search"
        spellcheck="false"
        placeholder="Filter"
        [matTooltip]="fullTextSearch"
        matTooltipClass="datex-control-tooltip">
    </div>
  </ng-container>

  <ng-container filters>
    <div class="fieldsetsContainer" [formGroup]="formGroup">
      <div class="fieldsetsGroup">
      <div data-cy="field-id-project" *ngIf="!filters.project.hidden && !filters.project.removed" 
            class="field-container full {{filters.project.invalid ? 'invalid' : ''}} {{filters.project.control.disabled ? 'field-container-disabled' : ''}}"
            [ngStyle]="filters.project.styles.style"
            [ngClass]="filters.project.styles.classes">
        <div class="label-container"
             [matTooltip]="filters.project.label + (filters.project.required ? ' (required)' : '')"
             matTooltipClass="datex-control-tooltip">
          <label data-cy="field-label" class="datex-label">{{filters.project.label}}<span *ngIf="filters.project.required" class="required-asterisk">*</span>
          </label>
        </div>
        <InventoryCounts-projects_dd_single 
            data-cy="selector"
            [type]="filters.project.control.type"
            formControlName="project"
            (displayTextChange)="filters.project.control.displayText=$event"
            [placeholder]="filters.project.control.placeholder"
            [styles]="filters.project.control.styles"
            [tooltip]="filters.project.control.tooltip"
        >
        </InventoryCounts-projects_dd_single>
        <ng-container *ngIf="filters.project.invalid">
          <ng-container *ngFor="let error of filters.project.errors">
            <span class="invalid-message">
              {{error}}
            </span>
          </ng-container>
        </ng-container>
      </div>      <div data-cy="field-id-status" *ngIf="!filters.status.hidden && !filters.status.removed" 
            class="field-container standard {{filters.status.invalid ? 'invalid' : ''}} {{filters.status.control.disabled ? 'field-container-disabled' : ''}}"
            [ngStyle]="filters.status.styles.style"
            [ngClass]="filters.status.styles.classes">
        <div class="label-container"
             [matTooltip]="filters.status.label + (filters.status.required ? ' (required)' : '')"
             matTooltipClass="datex-control-tooltip">
          <label data-cy="field-label" class="datex-label">{{filters.status.label}}<span *ngIf="filters.status.required" class="required-asterisk">*</span>
          </label>
        </div>
        <Lots-lot_statuses_dd_single 
            data-cy="selector"
            [type]="filters.status.control.type"
            formControlName="status"
            (displayTextChange)="filters.status.control.displayText=$event"
            [placeholder]="filters.status.control.placeholder"
            [styles]="filters.status.control.styles"
            [tooltip]="filters.status.control.tooltip"
        >
        </Lots-lot_statuses_dd_single>
        <ng-container *ngIf="filters.status.invalid">
          <ng-container *ngFor="let error of filters.status.errors">
            <span class="invalid-message">
              {{error}}
            </span>
          </ng-container>
        </ng-container>
      </div>      <div data-cy="field-id-storage_category_rules" *ngIf="!filters.storage_category_rules.hidden && !filters.storage_category_rules.removed" 
            class="field-container standard {{filters.storage_category_rules.invalid ? 'invalid' : ''}} {{filters.storage_category_rules.control.disabled ? 'field-container-disabled' : ''}}"
            [ngStyle]="filters.storage_category_rules.styles.style"
            [ngClass]="filters.storage_category_rules.styles.classes">
        <div class="label-container"
             [matTooltip]="filters.storage_category_rules.label + (filters.storage_category_rules.required ? ' (required)' : '')"
             matTooltipClass="datex-control-tooltip">
          <label data-cy="field-label" class="datex-label">{{filters.storage_category_rules.label}}<span *ngIf="filters.storage_category_rules.required" class="required-asterisk">*</span>
          </label>
        </div>
        <InventoryCounts-storage_category_rules_dd_single 
            data-cy="selector"
            [type]="filters.storage_category_rules.control.type"
            formControlName="storage_category_rules"
            (displayTextChange)="filters.storage_category_rules.control.displayText=$event"
            [placeholder]="filters.storage_category_rules.control.placeholder"
            [styles]="filters.storage_category_rules.control.styles"
            [tooltip]="filters.storage_category_rules.control.tooltip"
        >
        </InventoryCounts-storage_category_rules_dd_single>
        <ng-container *ngIf="filters.storage_category_rules.invalid">
          <ng-container *ngFor="let error of filters.storage_category_rules.errors">
            <span class="invalid-message">
              {{error}}
            </span>
          </ng-container>
        </ng-container>
      </div>      </div>
    </div>
  </ng-container>

  <ng-container gridColumnDef="vendorlot_lookupcode">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.vendorlot_lookupcode.displayControl.styles.style"
          [ngClass]="row.cells.vendorlot_lookupcode.displayControl.styles.classes"
          [matTooltip]="row.cells.vendorlot_lookupcode.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.vendorlot_lookupcode.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="material_lookupcode">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.material_lookupcode.displayControl.styles.style"
          [ngClass]="row.cells.material_lookupcode.displayControl.styles.classes"
          [matTooltip]="row.cells.material_lookupcode.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.material_lookupcode.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="material_status_name">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.material_status_name.displayControl.styles.style"
          [ngClass]="row.cells.material_status_name.displayControl.styles.classes"
          [matTooltip]="row.cells.material_status_name.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.material_status_name.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="material_temperature_category_rule_name">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.material_temperature_category_rule_name.displayControl.styles.style"
          [ngClass]="row.cells.material_temperature_category_rule_name.displayControl.styles.classes"
          [matTooltip]="row.cells.material_temperature_category_rule_name.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.material_temperature_category_rule_name.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="vendorlot_description">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.vendorlot_description.displayControl.styles.style"
          [ngClass]="row.cells.vendorlot_description.displayControl.styles.classes"
          [matTooltip]="row.cells.vendorlot_description.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.vendorlot_description.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>

<ng-container bottomToolbar>
</ng-container>


</datex-grid>
<div *ngIf="$hasMissingRequiredInParams" class="missing-params">
  <h3>Please provide {{$missingRequiredInParams.toString()}}</h3>
</div>
